import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { initiateAXIOS } from "../../../../config/axios";
import { announcementAPILimit } from "../../../../api";
import Announcement from "../../../../models/AnnouncementModel";
import {
  CustomTextField,
  TypographyLarge,
} from "../../../../components/customComponent";
import { ascending } from "../../../../helpers/sorting";
import { useDispatch, useSelector } from "react-redux";
import { linkDisruption } from "../../../store/actions/smrt/disruptionAction";
import { logger } from "../../../../helpers/logger";
import { useTranslation } from "react-i18next";

const LinkAnnouncement = ({ announcementStatus, disruptionStatus }) => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const dispatch = useDispatch();
  const { disruptionAnnouncement } = useSelector(
    (state) => state.smrtDisruption
  );

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [announcementData, setAnnouncementData] = useState([]);
  const [linkedAnnouncementData, setLinkedAnnouncementData] = useState([]);
  const [select, setSelect] = useState("");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelect = (e) => {
    setSelect(e.target.value);
  };

  const handleSubmit = () => {
    const payload = { announcementId: +select };
    dispatch(linkDisruption(payload));
    handleClose();
  };

  const getAnnouncements = async () => {
    const access_token = sessionStorage.getItem("access_token");
    try {
      const { data } = await initiateAXIOS.get(announcementAPILimit, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      const announcementList = data.items;

      let announcements = [];
      announcementList.map((item) =>
        announcements.push(new Announcement(item))
      );
      setAnnouncementData(ascending(announcements, "name"));
    } catch (error) {
      // setIsError(true);
      // setErrorMessage(error.response.data.message);
      logger.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      if (Object.keys(disruptionAnnouncement).length !== 0) {
        setLinkedAnnouncementData(disruptionAnnouncement);
        setSelect(disruptionAnnouncement.id);
      }
      getAnnouncements();
    }
  }, [open, disruptionAnnouncement]);

  return (
    <>
      {announcementStatus === "LINKED" ? (
        <>
          <Button
            startIcon={
              <CheckCircleIcon
                fontSize="medium"
                sx={{
                  color:
                    disruptionStatus === "ANNOUNCEMENT_ON"
                      ? "rgba(0, 0, 0, 0.26)"
                      : "#1C4ED8",
                }}
              />
            }
            variant="outlined"
            {...(disruptionStatus === "ANNOUNCEMENT_ON"
              ? { disabled: true }
              : { disabled: false, onClick: handleOpen })}
          >
            Linked
          </Button>
        </>
      ) : announcementStatus === "UNLINKED" ? (
        <>
          <Button
            onClick={handleOpen}
            startIcon={<LinkIcon fontSize="medium" />}
            variant="contained"
            color="primary"
            sx={{ whiteSpace: "nowrap", minWidth: "auto" }}
          >
            Link Announcement
          </Button>
        </>
      ) : (
        <Button
          onClick={handleOpen}
          startIcon={<LinkIcon fontSize="small" />}
          variant="contained"
          fullWidth
          sx={{ boxShadow: 3 }}
        >
          Link Announcement
        </Button>
      )}

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          Link Announcement
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="small" color="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box>
            <TypographyLarge>
              Currently Linked :{" "}
              <span style={{ fontWeight: "500" }}>
                {linkedAnnouncementData?.name === undefined
                  ? "-"
                  : linkedAnnouncementData?.name}
              </span>
            </TypographyLarge>
          </Box>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress size={24} sx={{ color: "#1C4ED8" }} />
            </Box>
          ) : (
            <Box>
              <CustomTextField
                select
                required
                SelectProps={{ native: true }}
                fullWidth
                margin="dense"
                name="announcementId"
                value={select}
                onChange={handleSelect}
              >
                <option value="" disabled>
                  Choose Announcement
                </option>
                {announcementData?.map((announcement) => (
                  <option value={announcement.id} key={announcement.id}>
                    {announcement.name}
                  </option>
                ))}
              </CustomTextField>
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button fullWidth variant="outlined" onClick={handleClose}>
            {tCommon("cancelBtn")}
          </Button>

          <Button fullWidth variant="contained" onClick={handleSubmit}>
            {t("link.submitBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LinkAnnouncement;
